import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import LandingPage from "../Pages/LandingPage";
import Login from "../Pages/Login";
import Register from "../Pages/Register";
import Dashboard from "../Pages/Dashboard";
import CreateUser from "../Pages/CreateUser";
import UserManagement from "../Pages/UserManagement";
import UpdatePassword from "../Pages/UpdatePassword";
import TestYubiKey from "../Pages/TestYubiKey";
import RegisterCustomerCode from "../Pages/RegisterCustomerCode";

const isAuthenticated = () => {
  return localStorage.getItem('@user') === "true";
};

const HomeGate = () =>
  isAuthenticated() ? <Navigate to="/dashboard" replace /> : <LandingPage />;

const Protected = ({ children }) =>
  isAuthenticated() ? children : <Navigate to="/" replace />;

const Rotas = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeGate />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/create-user" element={<Protected><CreateUser /></Protected>} />
        <Route path="/user-management" element={<Protected><UserManagement /></Protected>} />
        <Route path="/update_password" element={<Protected><UpdatePassword /></Protected>} />
        <Route path="/test-yubikey" element={<Protected><TestYubiKey /></Protected>} />
        <Route path="/register-customer-code" element={<Protected><RegisterCustomerCode /></Protected>} />
        <Route path="*" element={<Navigate to={isAuthenticated() ? "/hello" : "/"} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Rotas;
